module.exports = __webpack_public_path__ + "static/media/LOGO_SIMA_png-03 (1).2791d86f.png";